import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { CitationView } from '@/module/Author/Citation/CitationView';
import { getCitationOptions } from '@/module/Author/Citation/model/CitationQuery';

export const Route = createFileRoute('/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout/')(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  const { citationId, bookId } = Route.useParams();
  const { data: citation } = useSuspenseQuery(getCitationOptions(bookId, citationId));

  return (
    <CitationView
      citation={citation}
      publicationId={Number(bookId)}
    />
  );
}
